// extracted by css-extract-rspack-plugin
export default {"listbox":"dX0FS"};